export default __webpack_public_path__ + "static/media/DIEGO BULLRICH.0c89a253.jpg";